import { RadioGroup } from "@headlessui/react";
import { ComponentPropsWithoutRef } from "react";
import cn from "../util/cn";
import RadioButton from "./RadioButton";

type ButtonGroupProps<T> = Omit<ComponentPropsWithoutRef<typeof RadioGroup>, "onChange"> & {
  values: { value: T; title: string; disabled?: boolean }[];
  onChange: (value: T) => void;
};

const ButtonGroup = <T extends string>({
  values,
  disabled: groupDisabled = false,
  onChange,
  className,
  ...otherProps
}: ButtonGroupProps<T>) => (
  <RadioGroup
    disabled={groupDisabled}
    className={cn("inline-flex space-x-2", className)}
    onChange={(value) => onChange(value as T)}
    {...otherProps}
  >
    {values.map(({ value, title, disabled }) => (
      <RadioButton key={value} value={value} disabled={groupDisabled || disabled}>
        {title}
      </RadioButton>
    ))}
  </RadioGroup>
);

export default ButtonGroup;
